import feather from "feather-icons";

$(function(){
    feather.replace();
});
